import actionTypes from '../constants/action-types';

const setHoveredElement = (elementId) => ({
  type: actionTypes.SET_HOVERED_ELEMENT,
  payload: {
    elementId,
  },
});

export default setHoveredElement;
